import React from 'react';
import TableHeadMaterial from '@material-ui/core/TableHead';

const TableCell = ({ children, ...rest }) => (
  <TableHeadMaterial {...rest}>{children}</TableHeadMaterial>
);

export default TableCell;
